export default {
  "/views/agency": {
    router: [
      {
        path: "/views/agency/brief",
        name: "Brief",
        hidden: false,
        meta: {
          title: "研究中心简介",
        },
      },
      {
        path: "/views/agency/workReport",
        name: "WorkReport",
        hidden: false,
        meta: {
          title: "年度工作报告",
        },
        children: [
          {
            path: "/views/agency/workReport/2024",
            name: "Report2024",
            hidden: false,
            meta: {
              title: "2024年度"
            },
          },
          {
            path: "/views/agency/workReport/2023",
            name: "Report2023",
            hidden: false,
            meta: {
              title: "2023年度"
            },
          }
        ]
      },
      {
        path: "/views/agency/xuewei",
        name: "Xuewei",
        hidden: false,
        meta: {
          title: "学术委员会",
        },
      },
      {
        path: "/views/agency/expert",
        name: "Expert",
        hidden: false,
        meta: {
          title: "专家学者",
        },
        children: [
          {
            path: "/views/agency/expert/expert1",
            name: "Expert1",
            hidden: false,
            meta: {
              title: "本院学者",
              detailName: "Expert1Details"
            },
          },
          {
            path: "/views/agency/expert/expert2",
            name: "Expert2",
            hidden: false,
            meta: {
              title: "特聘专家",
              detailName: "Expert2Details"
            },
          },
          {
            path: "/views/agency/expert/expert3",
            name: "Expert3",
            hidden: false,
            meta: {
              title: "双聘研究员",
              detailName: "Expert3Details"
            },
          },
          {
            path: "/views/agency/expert/expert4",
            name: "Expert4",
            hidden: false,
            meta: {
              title: "兼职研究员",
              detailName: "Expert4Details"
            },
          },
        ]
      },
      {
        path: "/views/agency/contact",
        name: "Contact",
        hidden: false,
        meta: {
          title: "联系我们",
        },
      }
    ]
  },
  "/views/news": {
    router: [
      {
        path: "/views/news/lastNews",
        name: "LastNews",
        hidden: false,
        meta: {
          title: "最新动态",
        },
      },
      {
        path: "/views/news/notice",
        name: "Notice",
        hidden: false,
        meta: {
          title: "通知公告",
        },
      }
    ]
  },
  "/views/activity": {
    router: [
      {
        path: "/views/activity/yugao",
        name: "Yugao",
        hidden: false,
        meta: {
          title: "活动预告",
        },
      },
      {
        path: "/views/activity/qianyan",
        name: "Qianyan",
        hidden: false,
        meta: {
          title: "前沿观点",
        },
      }
    ]
  },
  "/views/study": {
    router: [
      {
        path: "/views/study/sudi",
        name: "Sudi",
        hidden: false,
        meta: {
          title: "学术著作",
        },
      },
      {
        path: "/views/study/qikan",
        name: "Qikan",
        hidden: false,
        meta: {
          title: "期刊论文",
        },
      },
      {
        path: "/views/study/subjectProject",
        name: "SubjectProject",
        hidden: false,
        meta: {
          title: "课题项目",
        },
        children: [
          {
            path: "/views/study/subjectProject/subpro1",
            name: "Subpro1",
            hidden: false,
            meta: {
              title: "国家级课题",
              detailName: "Subpro1Details"
            },
          },
          {
            path: "/views/study/subjectProject/subpro2",
            name: "Subpro2",
            hidden: false,
            meta: {
              title: "省部级课题",
              detailName: "Subpro2Details"
            },
          },
          {
            path: "/views/study/subjectProject/subpro3",
            name: "Subpro3",
            hidden: false,
            meta: {
              title: "博士后项目",
              detailName: "Subpro3Details"
            },
          }
        ]
      },
      {
        path: "/views/study/rongyu",
        name: "Rongyu",
        hidden: false,
        meta: {
          title: "荣誉奖项",
        },
      },
    ]
  },
  "/views/chinaStory": {
    router: [
      {
        path: "/views/chinaStory/brief",
        name: "ChinaStoryBrief",
        hidden: false,
        meta: {
          title: "项目简介",
        },
      },
      {
        path: "/views/chinaStory/dashiji",
        name: "Dashiji",
        hidden: false,
        meta: {
          title: "教育部重大课题大事记",
        },
      },
      {
        path: "/views/chinaStory/baodao",
        name: "Baodao",
        hidden: false,
        meta: {
          title: "新闻报道",
        },
      },
      {
        path: "/views/chinaStory/chengguo",
        name: "Chengguo",
        hidden: false,
        meta: {
          title: "项目成果",
        },
      }
    ]
  }
}